import { useToken } from "@/pages/token-v2/hooks/use-token";
import Avatar from "@/ui/avatar";
import { Balance } from "@/ui/formats";
import { IconComponent } from "@/ui/icon";
import { UnstyledButton } from "@mantine/core";
import clsx from "clsx";

const MarketLimitButtons = ({
  isInstant,
  isSell = false,
  onMarketClick = () => {},
  onLimitClick = () => {},
  showBalance = true,
}: {
  isInstant: boolean;
  isSell?: boolean;
  onMarketClick?: () => void;
  onLimitClick?: () => void;
  showBalance?: boolean;
}) => {
  const token = useToken();

  const nativeBalance = token?.balanceNative ?? 0;
  const tokenBalance = token?.balance ?? 0;

  return (
    <div
      className={`flex w-full items-center ${showBalance ? "justify-between" : "justify-end"}`}
    >
      <div className="flex gap-[0.625rem]">
        <UnstyledButton onClick={onMarketClick} className="flex items-center">
          <span
            className={clsx(
              isInstant ? "text-white" : "text-gray-400",
              "text-xs font-semibold"
            )}
          >
            Market
          </span>
        </UnstyledButton>
        <UnstyledButton onClick={onLimitClick} className="flex items-center">
          <span
            className={clsx(
              !isInstant ? "text-white" : "text-gray-400",
              "text-xs font-semibold"
            )}
          >
            Limit
          </span>
        </UnstyledButton>
      </div>
      {showBalance && (
        <div className="flex items-center gap-x-[0.3125rem]">
          {isSell ? (
            <Avatar source={token?.icon ?? ""} size="bigger" />
          ) : (
            <IconComponent
              name="solanaLogo"
              className="h-[1.1875rem] w-[1.1875rem]"
            />
          )}
          <Balance
            value={isSell ? Number(tokenBalance) : Number(nativeBalance)}
          />
        </div>
      )}
    </div>
  );
};

export default MarketLimitButtons;
